import * as React from 'react';

import App from 'src/state/App';
import Room from 'src/state/Room';
import RoomPage from 'src/state/RoomPage';
import { assert, assertType } from 'src/util';

import SelectorDialog from '../SelectorDialog';

type SDT = {
  type: 'RoomSelector',
  option: string,
  metadata: {},
};

export type State = SelectorDialog.State<SDT>;

export const Component: React.SFC<{
  store: App.Store,
  page: RoomPage,
  localState: SelectorDialog.State<SDT>,
  roomHints: { [id: string]: string | null },
}> = ({ store, page, localState, roomHints }) => {
  const dispatch = store.dispatchRoomPage.bind(undefined, page.room);
  const hideDialog = () => RoomPage.hideDialog(dispatch);

  return SelectorDialog<SDT>({
    title: 'Select Room',
    options: Object.keys(roomHints),
    enableNew: true,
    dialogState: localState,
    OptionName: roomId => roomHints[roomId] || '(Unnamed Room)',
    selectionValid: (selection) => {
      if (selection.type === 'none') {
        return false;
      }

      const { newOptionText } = localState.data;

      if (selection.type === 'new' && newOptionText === '') {
        return false;
      }

      return true;
    },
    onSelection: (selection) => {
      const check = (() => {
        switch (selection.type) {
          case 'new': {
            const newRoom = Room({ name: localState.data.newOptionText });

            store.dispatch({
              type: 'multi',
              subActions: [
                {
                  type: 'AddRoom',
                  data: newRoom,
                },
                {
                  type: 'SetRoom',
                  data: newRoom,
                },
              ]
            });

            return null;
          }

          case 'existing': {
            store.dispatch({
              type: 'SetRoomIdName',
              data: {
                id: selection.data,
                name: roomHints[selection.data] || null,
              },
            });

            return null;
          }

          case 'none': {
            assert(false);

            return null;
          }
        }
      })();

      assertType<null>(check);
    },
    dispatch: newState => dispatch({
      type: 'set-dialog',
      data: newState,
    }),
    hideDialog,
    isHidden: () => page.dialog.hidden,
  });
};



// WEBPACK FOOTER //
// ./src/ui/Room/RoomSelectorDialog.tsx